export class SignInWrongPasswordError extends Error {
  public constructor() {
    super()

    this.message = 'firebaseErrors.authCodes.auth/wrong-password'
  }
}
